import { Heading, Link, Paragraph } from '@purpur/library';
import styled, { css } from 'styled-components';
import { match } from 'ts-pattern';

import { PlainLink } from '@telialt/common-plain-link/src';
import { getPurpurColor, getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

import { ValuePromptColorVariant } from './model';

export const ValuePromptHeading = styled(Heading)``;

export const ValuePromptParagraph = styled(Paragraph)`
    margin-top: ${getPurpurSpacing('100')};
`;

type ColorVariantProps = {
    $colorVariant?: ValuePromptColorVariant;
};

const ValuePromptContainer = styled.div<ColorVariantProps>`
    ${({ $colorVariant }) =>
        match($colorVariant)
            .with(
                'light-purple',
                () => css`
                    ${ValuePromptHeading},
                    ${ValuePromptParagraph} {
                        color: ${getPurpurColor('textToneOnToneSecondary')};
                    }
                `,
            )
            .with(
                'light-beige',
                () => css`
                    ${ValuePromptHeading},
                    ${ValuePromptParagraph} {
                        color: ${getPurpurColor('textToneOnToneTertiary')};
                    }
                `,
            )
            .otherwise(() => undefined)};
`;

export const ValuePromptContainerIllustrative = styled(ValuePromptContainer)``;

export const ValuePromptContainerCompact = styled(ValuePromptContainer)`
    display: grid;
    grid-template-columns: auto 1fr;
    gap: ${getPurpurSpacing('100')};
`;

export const ValuePromptCTA = styled(Link)`
    margin-top: ${getPurpurSpacing('100')};
`;

export const ValuePromptButtonCTA = styled(PlainLink)`
    margin-top: ${getPurpurSpacing('100')};
`;

export const ValuePromptImageIllustrative = styled.img`
    height: 5rem;
    width: 5rem;
    margin-bottom: ${getPurpurSpacing('200')};
`;

export const ValuePromptImageCompact = styled.img`
    height: 1.5rem;
    width: 1.5rem;
`;
